export const SET_COUPON_TEMPLATE_DRAFT = 'PRO/SET_COUPON_TEMPLATE_DRAFT'
export type SET_COUPON_TEMPLATE_DRAFT = typeof SET_COUPON_TEMPLATE_DRAFT

export const CLEAR_COUPON_TEMPLATE_DRAFT = 'PRO/CLEAR_COUPON_TEMPLATE_DRAFT'
export type CLEAR_COUPON_TEMPLATE_DRAFT = typeof CLEAR_COUPON_TEMPLATE_DRAFT

export const SET_ALL_COUPON_TEMPLATES = 'PRO/SET_ALL_COUPON_TEMPLATES'
export type SET_ALL_COUPON_TEMPLATES = typeof SET_ALL_COUPON_TEMPLATES
